// extracted by mini-css-extract-plugin
export default {"EmojiPickerContainer":"styles_EmojiPickerContainer__TCblT"};